import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const useBudgetCategories = () => {
  const queryFn = useApiRequest({
    url: "budget-categories",
    method: HttpMethod.Get,
  });

  return useQuery({
    queryKey: ["budget-categories"],
    queryFn,
    select: (data) =>
      data.reduce((acc, category) => {
        acc[category.code] = category;
        return acc;
      }, {}),
    placeholderData: [],
  });
};
